{
  "title": "Chaos Bolt",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "1st-level evocation",
  "level": 1,
  "castingTime": "1 action",
  "range": "120 feet",
  "components": "V, S",
  "duration": "Instantaneous",
  "description": [
    "You hurl an undulating, warbling mass of chaotic energy at one creature in range. Make a ranged spell attack against the target. On a hit, the target takes 2d8 + 1d6 damage. Choose one of the d8s. The number rolled on that die determines the attack's damage type, as shown below.",
    "d8",
    "Damage Type",
    "1",
    "Acid",
    "2",
    "Cold",
    "3",
    "Fire",
    "4",
    "Force",
    "5",
    "Lightning",
    "6",
    "Poison",
    "7",
    "Psychic",
    "8",
    "Thunder",
    "If you roll the same number on both d8s, the chaotic energy leaps from the target to a different creature of your choice within 30 feet of it. Make a new attack roll against the new target, and make a new damage roll, which could cause the chaotic energy to leap again.",
    "A creature can be targeted only once by each casting of this spell.",
    "At Higher Levels. When you cast this spell using a spell slot of 2nd level or higher, each target takes 1d6 extra damage of the type rolled for each slot level above 1st."
  ],
  "spellLists": ["sorcerer"]
}
